import { HtmlHTMLAttributes } from 'react';
import './index.less';
import classNames from 'classnames';

interface IAITeacherIconProps extends HtmlHTMLAttributes<HTMLDivElement> {
  size?: number;
  disabled?: boolean;
}

export const AITeacherIcon = (props: IAITeacherIconProps)=>{
  return <div {...props} data-disabled={props.disabled} className={classNames('ai-teacher-icon', props.className)} style={{width: props.size, height: props.size, ...props.style}}>
    <img className='ai-teacher-icon-img' alt='' src='https://duy-ielts-public.oss-cn-hangzhou.aliyuncs.com/front/teacher-1.png'></img>
  </div>;
};
